import { Component, Input } from '@angular/core';
import {
    SporitelnaBankAccountObject,
} from '@libs/types/src/chcrm/object-type/sporitelna/sporitelna-bank-account.object';
import { ibanToAccountNumber } from '../../../../../../utils/iban-to-account-number';
import { TranslatePipe } from '@ngx-translate/core';


@Component({
    selector: 'app-sporitelna-bank-account',
    templateUrl: 'sporitelna-bank-account.component.html',
    styleUrls: ['sporitelna-bank-account.component.scss'],
    imports: [
    TranslatePipe
],
})
export class SporitelnaBankAccountComponent {

    @Input() account!: SporitelnaBankAccountObject | any;

    protected readonly ibanToAccountNumber = ibanToAccountNumber;
}
